export default "__VITE_ASSET__CKEcLc0e__"